(() => {
  'use strict';
  const root = document.querySelector('[data-artist-native-transition]');
  if (!root) {
    const resolveInformation = () => {
      const match = location.hash.match(/^#metallico-information-(intro|craft|specs|sizes)$/);
      if (!match) return;
      const target = document.querySelector(`[data-artist-information="${match[1]}"] [id]`) || document.querySelector('[id^="ArtistProfile-"]');
      if (!target) return;
      history.replaceState(null, '', `${location.pathname}${location.search}#${target.id}`);
      target.scrollIntoView({ block: 'start' });
      target.focus({ preventScroll: true });
    };
    window.addEventListener('hashchange', resolveInformation);
    resolveInformation();
    return;
  }
  if (root.hasAttribute('data-editor-preview')) return;
  const route = () => {
    const hash = location.hash.slice(1);
    const artistSlug = hash.replace(/^(artist-|ArtistProfile-|ArtistInformation(?:Intro|Craft|Specs|Sizes)-)/, '');
    const link = [...root.querySelectorAll('[data-native-artist]')].find(item => item.dataset.nativeArtist === artistSlug);
    const destination = link?.getAttribute('href') || root.dataset.nativeCollectionUrl;
    if (!destination) return;
    const target = new URL(destination, location.origin);
    if (target.origin !== location.origin) return;
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) target.searchParams.set('preview_theme_id', previewTheme);
    const information = hash.match(/^ArtistInformation(Intro|Craft|Specs|Sizes)-/);
    if (link && information) target.hash = `metallico-information-${information[1].toLowerCase()}`;
    else if (link && hash.startsWith('ArtistProfile-')) target.hash = `ArtistProfile-${link.dataset.nativeProductId}`;
    if (target.href === location.href) return;
    // Replace the retired view so Back returns to the page preceding the old URL.
    location.replace(target.href);
  };
  window.addEventListener('hashchange', route);
  route();
})();
